import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourDashboardApi from '@/features/dashboard/tours/api/tourDashboardApi.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { TourFinanceDashboardDto } from '@/features/dashboard/tours/types/dashboard/dto/TourFinanceDashboardDto.ts';

const useGetTourFinanceDashboard = (tourId: string) =>
  useQuery(getTourFinanceDashboardQueryOptions(tourId));

export const getTourFinanceDashboardQueryOptions = (
  tourId: string,
): UseQueryOptions<TourFinanceDashboardDto> => ({
  queryKey: tourDashboardApiQueryKeys.finance(tourId),
  queryFn: () => tourDashboardApi.getFinance(tourId),
  enabled: tourId !== undefined,
  staleTime: 1000 * 60,
});

export default useGetTourFinanceDashboard;
